// extracted by mini-css-extract-plugin
module.exports = {"HeadCarousel":"HeadCarousel_HeadCarousel__0us5D"};